import { render, staticRenderFns } from "./TTextarea.vue?vue&type=template&id=47806b42"
import script from "./TTextarea.vue?vue&type=script&lang=js"
export * from "./TTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports